export default __webpack_public_path__ + "static/media/linuxclusterimg.c9838525.png";